export const extractYearFromString = (text: string): string | null => {
  const yearMatch = /(\d{4})$/; // Regex para detectar el año
  const match = text.match(yearMatch);
  return match ? match[0] : null; // Devuelve el año o null si no se encuentra
}
